import { useMemo } from 'react';
import styles from '../styles.module.scss';
import { Button, FormGroup, Input } from '@starsoft/common/components';

export default function UserPaymentDetailsFormLayoutSkeleton() {
  const Rows: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 5 }).map((_, index) => (
        <FormGroup
          key={`form-group-skeleton-${index}`}
          isLoading
          loading={{ label: true }}
        >
          <Input isLoading secondarySkeleton />
        </FormGroup>
      )),
    [],
  );

  return (
    <>
      <div className={styles.container__content}>{Rows}</div>
      <div className={styles.container__padded}>
        <Button isSkeleton />
      </div>
    </>
  );
}
